/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDetentionProfile.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/detention-profile";

export class AutogenModelDetentionProfile<RowType extends ModelRow> extends Endpoint<RowType, RowDetentionProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDetentionProfile extends ModelRow<RowDetentionProfileFields> {
	constructor(values?: Partial<RowDetentionProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDetentionProfileFields {
	auth_blank: string;
	auth_status: string;
	billing_approved: string;
	company_id: string;
	customer_id: string;
	descr: string;
	detention_charge_status: string;
	detention_payment_status: string;
	dispatcher: string;
	driver_fleet: string;
	driver_manager: string;
	exclude_customers: string;
	id: string;
	location_type: string;
	locations_list: string;
	movement_status: string;
	operations_user_id: string;
	payment_approval: string;
	status: string;
	stop_type: string;
	tractor_fleet: string;
}

